import { render, staticRenderFns } from "./RemocaoExternaComponente.vue?vue&type=template&id=352dd480&scoped=true"
import script from "./RemocaoExternaComponente.vue?vue&type=script&lang=js"
export * from "./RemocaoExternaComponente.vue?vue&type=script&lang=js"
import style0 from "./RemocaoExternaComponente.vue?vue&type=style&index=0&id=352dd480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352dd480",
  null
  
)

export default component.exports